import { render, staticRenderFns } from "./ProMade.vue?vue&type=template&id=1f87b184&scoped=true&"
import script from "./ProMade.vue?vue&type=script&lang=js&"
export * from "./ProMade.vue?vue&type=script&lang=js&"
import style0 from "./ProMade.vue?vue&type=style&index=0&id=1f87b184&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f87b184",
  null
  
)

export default component.exports